import { ButtonWidget } from '@tableau/widgets';
import { ButtonType } from '@tableau/widgets/lib/src/widgets/Button/ButtonWidget';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { SvgExpand } from '../../../../../gen-src/icons';
import { SiteUrlsContext } from '../../../data-catalog-shared';
import { TableauExpressionFormatter } from '../tableauExpression/components/TableauExpressionFormatter';
import { CalculationDialog } from './CalculationDialog';
import { SheetFieldWithCalculation } from './SheetField';
import {
  ExpandIconWrapper,
  FieldCardDetailText,
  FieldCardDetailTitle,
  FieldCardDetailTitleWrapper
} from './VizClientFieldCardStyles';

export type CalculationDetailsProps = {
  readonly field: SheetFieldWithCalculation;
  readonly workbookVizportalUrlId?: string;
};

export function CalculationDetails(props: CalculationDetailsProps): JSX.Element {
  const urls = React.useContext(SiteUrlsContext);
  const [isOpen, toggleDialog] = React.useState(false);
  const openDialog = () => toggleDialog(true);
  const onClose = () => toggleDialog(false);

  return (
    <>
      <FieldCardDetailTitleWrapper>
        <FieldCardDetailTitle>{Messages.DataDetailsCalculation()}</FieldCardDetailTitle>
        <ExpandIconWrapper>
          <ButtonWidget
            buttonType={ButtonType.Icon}
            handleClick={openDialog}
            title={Messages.DataDetailsCalculationDialogExpandAltText()}
            testId={'data-details-calculation-expand'}
            getContent={() => { return <SvgExpand />; }}
          />
        </ExpandIconWrapper>
      </FieldCardDetailTitleWrapper>
      <FieldCardDetailText>
        <>
          <TableauExpressionFormatter
            expression={props.field.formula ?? ''}
            fields={props.field.fields}
            parameters={props.field.parameters}
            makeFieldUrl={(fieldId) =>
              props.workbookVizportalUrlId
                ? urls.workbookLineageFieldUrl(props.workbookVizportalUrlId, fieldId)
                : ''
            }
            openLinksInNewTab={true}
          />
          <CalculationDialog
            isOpen={isOpen}
            onClose={onClose}
            field={props.field}
            workbookVizportalUrlId={props.workbookVizportalUrlId}
            siteUrls={urls}
          />
        </>
      </FieldCardDetailText>
    </>
  );
}
